export default "__VITE_ASSET__CL0YNZ5Q__"